
import AcademicYearList from 'Containers/BasicDetails/AcademicYearList';

import ManageYear from 'Containers/BasicDetails/ManageYear';
import VisitList from 'Containers/BasicDetails/VisitList';
import VisitForm from 'Containers/BasicDetails/VisitForm';
import CompanyJsonConfigList from 'Containers/Company/CompanyJsonConfigList';
import CompanyJsonConfigPage from 'Containers/Company/CompanyJsonConfigPage';
import ClientLocations from 'Containers/BasicDetails/ClientLocations';
import CompanyOverallVisits from 'Containers/BasicDetails/CompanyOverallVisits';
import EdubriczAds from 'Containers/BasicDetails/EdubriczAds';
import FeatureAdds from 'Containers/BasicDetails/FeatureAdds';
import FeatureAddEdit from 'Containers/BasicDetails/FeatureAddEdit';
import EdubriczPermission from 'Containers/BasicDetails/EdubriczPermission';

const Actions = {
    academic_year: {
        view: {
            codenames: [],
            action_code: 'visible_academic_year_view',
            is_superuser_action: false,
            name: 'View Academic Year',
            label: 'Academic Year',
            action: 'sub-menu',
            url: '/academicyear/list',
            component: <AcademicYearList />,
            permission_needed: true,
            associated_urls: ['/basicdetails/academic-year/add'],
            exclude_roles: [7],
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        create: {
            codenames: [],
            action_code: 'visible_academic_year_add',
            is_superuser_action: false,
            name: 'Create Academic Year',
            label: 'Academic Year',
            action: 'action-url',
            url: '/basicdetails/academic-year/add',
            component: <ManageYear />,
            permission_needed: true,
            exclude_roles: [7],
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_academic_year_change',
            is_superuser_action: false,
            name: 'Update Academic Year',
            label: 'Academic Year',
            action: 'action',
            permission_needed: true,
            exclude_roles: [7],
        },
        delete: {
            codenames: [],
            action_code: 'visible_academic_year_delete',
            is_superuser_action: false,
            name: 'Delete Year',
            label: 'Academic Year',
            action: 'action',
            permission_needed: true,
            exclude_roles: [7],
        },
        name: 'Academic Year',
        type: 'Basic Details',
    },
    company_visit: {
        view: {
            codenames: [],
            action_code: 'visible_company_visit_view',
            is_superuser_action: false,
            name: 'View Visits',
            label: 'Visits',
            action: 'action',
            url: '/visits/list',
            component: <VisitList />,
            permission_needed: true,
            associated_urls: ['/visits'],
        },
        create: {
            codenames: [],
            action_code: 'visible_company_visit_add',
            is_superuser_action: false,
            name: 'Add Visit',
            label: 'Visit',
            action: 'action-url',
            url: '/visits',
            component: <VisitForm />,
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_company_visit_change',
            is_superuser_action: false,
            name: 'Update Visit',
            label: 'Visit',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_company_visit_delete',
            is_superuser_action: false,
            name: 'Delete Visit',
            label: 'Visit',
            action: 'action',
            permission_needed: true,
        },
        name: 'Visits',
        type: 'Support Visits',
    },
    company_visit_my: {
        view: {
            codenames: [],
            action_code: 'visible_company_visit_view',
            is_superuser_action: false,
            name: 'View My Visits',
            label: 'My Visits',
            action: 'action',
            url: '/visits/my',
            component: <VisitList />,
            permission_needed: true,
        },
        name: 'My Visits',
        type: 'Support Visits',
    },
    company_overall_visits: {
        view: {
            codenames: [],
            action_code: 'visible_company_overall_visits_view',
            is_superuser_action: false,
            name: 'View Company Overall Visits',
            label: 'Company Overall Visits',
            action: 'action',
            url: '/visits/company-overall',
            component: <CompanyOverallVisits />,
            permission_needed: true,
        },
        name: 'Company Overall Visits',
        type: 'Support Visits',
    },
    company_json_config: {
        view: {
            codenames: [],
            action_code: 'visible_company_json_config_view',
            is_superuser_action: false,
            name: 'View company JSON config',
            label: 'Company JSON config',
            action: 'sub-menu',
            url: '/company-json-config/list',
            component: <CompanyJsonConfigList />,
            permission_needed: true,
            associated_urls: ['/company-json-config'],
            exclude_roles: [7],
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        create: {
            codenames: [],
            action_code: 'visible_company_json_config_add',
            is_superuser_action: false,
            name: 'Add company JSON config',
            label: 'Company JSON config',
            action: 'action-url',
            url: '/company-json-config',
            component: <CompanyJsonConfigPage />,
            permission_needed: true,
            exclude_roles: [7],
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_company_json_config_change',
            is_superuser_action: false,
            name: 'Update company JSON config',
            label: 'Company JSON config',
            action: 'action',
            permission_needed: true,
            exclude_roles: [7],
        },
        delete: {
            codenames: [],
            action_code: 'visible_company_json_config_delete',
            is_superuser_action: false,
            name: 'Delete company JSON config',
            label: 'Company JSON config',
            action: 'action',
            permission_needed: true,
            exclude_roles: [7],
        },
        name: 'Company JSON config',
        type: 'Basic Details',
    },
    client_locations: {
        view: {
            codenames: [],
            action_code: 'visible_client_locations_view',
            is_superuser_action: false,
            name: 'View Client Locations',
            label: 'Location',
            action: 'sub-menu',
            url: '/basicdetails/client-locations',
            component: <ClientLocations />,
            permission_needed: true,
            associated_urls: ['/basicdetails/client-locations'],
        },
        name: 'Location',
        type: 'Basic Details',
    },
    edubricz_ads: {
        view: {
            codenames: [],
            action_code: 'visible_edubricz_ads_view',
            is_superuser_action: false,
            name: 'View Edubricz ads',
            label: 'Edubricz ads',
            action: 'sub-menu',
            url: '/basicdetails/edubricz-ads',
            component: <EdubriczAds />,
            permission_needed: true,
            associated_urls: ['/basicdetails/edubricz-ads'],
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        create: {
            codenames: [],
            action_code: 'visible_edubricz_ads_add',
            is_superuser_action: false,
            name: 'Upload Edubricz ads',
            label: 'Edubricz ads',
            action: 'action',
            permission_needed: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_edubricz_ads_delete',
            is_superuser_action: false,
            name: 'Delete Edubricz ads',
            label: 'Edubricz ads',
            action: 'action',
            permission_needed: true,
        },
        name: 'Edubricz ads',
        type: 'Basic Details',
    },
    feature_adds: {
        view: {
            codenames: [],
            action_code: 'visible_feature_adds_view',
            is_superuser_action: false,
            name: 'View Feature Adds',
            label: 'Feature Adds',
            action: 'sub-menu',
            url: '/basicdetails/feature-adds',
            component: <FeatureAdds />,
            permission_needed: true,
            associated_urls: ['/basicdetails/feature-adds'],
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        create: {
            codenames: [],
            action_code: 'visible_feature_adds_add',
            is_superuser_action: false,
            name: 'Add Feature Adds',
            label: 'Feature Adds',
            action: 'action',
            permission_needed: true,
        },
        update: {
            codenames: [],
            action_code: 'visible_feature_adds_change',
            is_superuser_action: false,
            name: 'Update Feature Adds',
            label: 'Feature Adds',
            action: 'action-url',
            url: '/basicdetails/feature-adds/edit/:id',
            component: <FeatureAddEdit />,
            permission_needed: true,
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        delete: {
            codenames: [],
            action_code: 'visible_feature_adds_delete',
            is_superuser_action: false,
            name: 'Delete Feature Adds',
            label: 'Feature Adds',
            action: 'action',
            permission_needed: true,
        },
        name: 'Feature Adds',
        type: 'Basic Details',
    },
    edubricz_permission: {
        view: {
            codenames: [],
            action_code: 'visible_edubricz_permission_view',
            is_superuser_action: false,
            name: 'View Edubricz Permission',
            label: 'Edubricz Permission',
            action: 'sub-menu',
            url: '/basicdetails/edubricz-permission',
            component: <EdubriczPermission />,
            permission_needed: true,
            associated_urls: ['/basicdetails/edubricz-permission'],
            hide_branch_dropdown: true,
            hide_board_dropdown: true,
        },
        name: 'Edubricz Permission',
        type: 'Basic Details',
    },
}

export default Actions